// extracted by mini-css-extract-plugin
export default {"catalog":"ySYPw ZdH1P","list":"_1Lmp","item":"s1AI2","moreWrapper":"nregY","moreButton":"J7bEl"};